interface DiagnosticTreatmentProps {
  status: string;
}

export function DiagnosticTreatment({ status }: DiagnosticTreatmentProps) {
  if (status === 'maintenance') {
    return <strong style={{ color: '#3cf05a' }}>Em Manutenção</strong>;
  }

  if (status === 'pending_treatment') {
    return <strong style={{ color: '#ff0000' }}>Tratamento Pendente</strong>;
  }

  if (status === 'treated') {
    return <strong style={{ color: '#f09c3c' }}>Tratamento em Aberto</strong>;
  }

  return <span>{status}</span>;
}
